// @flow
const VIRTUALIZED_TABLE_DEFAULTS = {
    BORDER_HEIGHT: 1,
    HEADER_HEIGHT: 39,
    ROW_HEIGHT: 52,
    TAB_INDEX: -1,
    ROUTE_BUTTON_CELL_WIDTH: 60,
};

// eslint-disable-next-line import/prefer-default-export
export { VIRTUALIZED_TABLE_DEFAULTS };
